import { RatingIcons, Stack } from '@packages/shared';
import { useConfig } from '@packages/utilities';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { RatingIconsVerifiedFragmentFragmentDoc } from '@packages/gql/generated/shopping/RatingIconsVerifiedFragmentFragmentDoc';
import { RatingInfo } from '../CustomerRatings/RatingInfo';

/* GraphQL */ `
  fragment RatingIconsVerifiedFragment on RatingProduct {
    avgRating
    reviewCount
  }
`;

export type RatingIconsVerifiedProps = {
  data: FragmentType<typeof RatingIconsVerifiedFragmentFragmentDoc>;
};

/**
 * RatingIconsVerified component shows review-icons,
 * the amount of given ratings and an information-icon
 * */
export const RatingIconsVerified = ({ data }: RatingIconsVerifiedProps) => {
  const {
    product: {
      reviews: { hintLayerId },
    },
  } = useConfig();
  const { avgRating, reviewCount } = getFragmentData(RatingIconsVerifiedFragmentFragmentDoc, data);

  return (
    <Stack direction="row" justifyContent="flex-start">
      <RatingIcons
        avgRating={avgRating}
        reviewCount={reviewCount}
        sx={{
          cursor: 'pointer',
          alignSelf: 'flex-start',
        }}
        onClick={() => {
          document
            .getElementById('customer-ratings')
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }}
      />
      <RatingInfo verifiedRatingsHintLayerId={hintLayerId} isInline />
    </Stack>
  );
};
